export default __webpack_public_path__ + "static/projects-banner-equipment-monitoring-a8ba20db3080ab5f705f8959481dfa4b.svg";